// extracted by mini-css-extract-plugin
export default {"lineDevider":"Line_lineDevider__WJ0Vf","first":"Line_first__y0gts","line":"Line_line__Yg9DT"};